import { FormattedNumber } from 'react-intl';
import { styled } from 'styled-components';

import commonEssence from '@sorare/core/src/assets/rewards/common-essence.png';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';

const CommonEssenceIcon = styled.img.attrs({ src: commonEssence, alt: '' })`
  height: 1.1em;
`;
type Props = {
  balance: number;
};

export const CommonBalance = ({ balance }: Props) => {
  return (
    <Horizontal>
      <CommonEssenceIcon />
      <LabelL
        bold
        color={balance >= 0 ? `var(--c-blue-300)` : `var(--c-red-400)`}
        className="whitespace-nowrap"
      >
        <FormattedNumber value={balance} />
      </LabelL>
    </Horizontal>
  );
};
